module.exports = __webpack_public_path__ + "img/banktransfer-light.2aca44df.svg";